module.exports = __webpack_public_path__ + "static/media/lohja.c4e77816.svg";